import HttpCLient from '@/src/lib/utils/httpClient';
import { ApiRouts } from '@/src/routes/routes';
import { favorite, obj, TAllWishlist } from '@/src/types/wishlist';

type TParams = {
  page?: string;
  pageCount?: string;
};
class WishlistServices extends HttpCLient {
  getWishlist = async (params?: TParams) => {
    try {
      const defaultParams = {
        page: params?.page || '1',
        pageCount: params?.pageCount || '40',
      };

      return await this.get<favorite[]>(ApiRouts.getWishlists, defaultParams, {
        next: {
          tags: ['wishlist'],
        },
        cache: 'force-cache',
      });
    } catch (error) {
      return [];
    }
  };

  getMyAllWishlist = async () => {
    try {
      return await this.get<TAllWishlist[]>(ApiRouts.getMyAllWishlist, undefined, {
        cache: 'force-cache',
      });
    } catch (error) {
      return [];
    }
  };

  AddOrDelete = async (data: obj) => {
    return await this.post<favorite[]>(ApiRouts.createWishlist, data);
  };
}
export const wishlistServices = new WishlistServices();
